module.exports = __webpack_public_path__ + "imejinlogo.230d33288e6e906bcaf9.png";